export default "__VITE_ASSET__DBhkB$SP__"